import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { ContextualMenuComponent } from 'src/app/controls/contextual-menu/contextual-menu.component';
import { ContextualMenuChange } from 'src/app/controls/contextual-menu/models/contextual-menu-change';
import { DefaultTreeItemComponent } from 'src/app/controls/default-composant/default-tree-item/default-tree-item.component';
import { Box } from 'src/app/models/box';
import { Rights } from 'src/app/models/enums/rights';
import { MemoryService } from 'src/app/services/memory.service';
import { ContextualMenuComponent as ContextualMenuComponent_1 } from '../../../../controls/contextual-menu/contextual-menu.component';

import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-box-tree-item',
    templateUrl: './box-tree-item.component.html',
    styleUrls: ['./box-tree-item.component.scss'],
    imports: [MatIconModule, ContextualMenuComponent_1]
})
export class BoxesTreeItemComponent extends DefaultTreeItemComponent<Box> {
    /**
     * Instance de la bannette affichée par le noeud courant.
     */
    @Input() box: Box;

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Editer' d'une bannette.
     */
    @Output()
    override itemEdited: EventEmitter<Box> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Consulter' d'une bannette.
     */
    @Output()
    override itemDisplayed: EventEmitter<Box> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'dupliquer' d'une bannette.
     */
    @Output()
    override itemDuplicated: EventEmitter<Box> = new EventEmitter();

    /**
     * Réference au composant du menu contextuel.
     */
    @ViewChild(ContextualMenuComponent, { static: false })
    contextuelMenu: ContextualMenuComponent<Box, MenuITemAction>;

    /**
     * Valeur indiquant si l'id est affiché.
     */
    public isIdVisible: boolean;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService
    ) {
        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur

        super(dialog, memoryService);

        this.isIdVisible = this.memoryService.getConnectedUser().params.idVisible === true;

        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur
        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.BoxCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.BoxEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.BoxDelete);
    }

    /**
     * Affiche le menu contextuel de la bannette courante.
     * @param event : Événement souris.
     * @param group : Bannette pour laquelle le menu contextuel doit être affiché.
     */
    public displayContextualMenu(event: MouseEvent, row: Box) {
        this.contextuelMenu.open(event, row);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement indiquant l'élément du menu contextuel cliqué.
     */
    public onMenuChanged(event: ContextualMenuChange<Box, MenuITemAction>) {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(this.box);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(this.box);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de la mise à jour.
            this.itemDuplicated.emit(this.box);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer la bannette '${event.context.name}'.`, event.context);
        }
    }
}
